import type { ResumeExperience, ResumeProject, ResumeSkill } from './types';

// Example content for the optional résumé/portfolio product variant (§11 of
// `docs/TEMPLATE_IMPROVEMENT_RECOMMENDATIONS.md`). Demonstrates that the same
// content-layer + section-toggle architecture used for the business
// one-pager (`src/pages/Home.tsx`) can ship a completely different product —
// a personal résumé/portfolio — by swapping the content module and the
// section registry, with zero changes to the underlying primitives
// (`Section`, `Card`, `Reveal`, `Button`, ...). See `src/pages/ResumeDemo.tsx`.
export const resumeContent = {
    profile: {
        name: 'Jordan Rivera',
        title: 'Product Designer & Front-End Engineer',
        summary:
            'I design and build accessible, performant web products end-to-end \u2014 from Figma to production React.',
    },
    experience: [
        {
            role: 'Senior Product Designer',
            company: 'Northwind Studio',
            period: '2022 \u2013 Present',
            description:
                'Leading design for a suite of B2B SaaS products, from research through shipped UI.',
        },
        {
            role: 'Front-End Engineer',
            company: 'Acme Digital',
            period: '2019 \u2013 2022',
            description:
                'Built and maintained design-system components used across a dozen client products.',
        },
    ] satisfies ResumeExperience[],
    skills: [
        { name: 'Product Design', level: 95 },
        { name: 'React / TypeScript', level: 90 },
        { name: 'Design Systems', level: 85 },
        { name: 'Accessibility (WCAG)', level: 80 },
    ] satisfies ResumeSkill[],
    projects: [
        {
            title: 'Design System Kit',
            description:
                'An open-source component library with 40+ accessible, themeable primitives.',
            href: '#',
        },
        {
            title: 'Commerce Dashboard Redesign',
            description:
                'Reduced average task completion time by 30% through a full IA and UI overhaul.',
            href: '#',
        },
    ] satisfies ResumeProject[],
};
